import { applicationLeadApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LEAD_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/lead`,
  {
    GET_LEAD_DATA: 'GET_LEAD_DATA',
    RESET_LEAD_DATA: 'RESET_LEAD_DATA',
    EDIT_LEAD: 'EDIT_LEAD',
    CREATE_LEAD: 'CREATE_LEAD',
    CONVERT_LEAD: 'CONVERT_LEAD',
  },
);

export const getLeadDataByApplicationAction = catchAsyncActionError(
  applicationId => async dispatch => {
    // The slice is shared across applications: clear it first so a failed load cannot leave the
    // previously loaded lead in place for the convert form to pre-fill.
    dispatch({ type: LEAD_ACTION_TYPE.RESET_LEAD_DATA });

    const { data } = await applicationLeadApi.getLeadDataByApplication({ applicationId });

    return dispatch({
      type: LEAD_ACTION_TYPE.GET_LEAD_DATA,
      payload: data,
    });
  },
);

export const editLeadByIdAction = params => async dispatch => {
  const { data } = await applicationLeadApi.editLeadByApplicationId(params);

  return dispatch({
    type: LEAD_ACTION_TYPE.EDIT_LEAD,
    payload: data,
  });
};

export const createLeadAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationLeadApi.createLead(params);

  return dispatch({
    type: LEAD_ACTION_TYPE.CREATE_LEAD,
    payload: data,
  });
});

export const convertLeadToLoanAction = (applicationId, dto) => async dispatch => {
  await applicationLeadApi.convertLeadToLoan(applicationId, dto);

  dispatch({
    type: LEAD_ACTION_TYPE.CONVERT_LEAD,
    payload: applicationId,
  });
};
